
/* styles */
require("!!vue-style-loader!css-loader!../../../node_modules/vue-loader/lib/style-rewriter?id=data-v-3de61608!postcss-loader!sass-loader!../../../node_modules/vue-loader/lib/selector?type=styles&index=0!./HomeButton.vue")

var Component = require("!../../../node_modules/vue-loader/lib/component-normalizer")(
  /* script */
  require("!!babel-loader!../../../node_modules/vue-loader/lib/selector?type=script&index=0!./HomeButton.vue"),
  /* template */
  require("!!../../../node_modules/vue-loader/lib/template-compiler?id=data-v-3de61608!../../../node_modules/vue-loader/lib/selector?type=template&index=0!./HomeButton.vue"),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports



//////////////////
// WEBPACK FOOTER
// ./src/spa/Home/HomeButton.vue
// module id = 257
// module chunks = 0